import React from 'react';
import { CheckIcon } from 'lucide-react';
import { formatPoints, images } from '../data/content';
export function FormatSection() {
  return <section className="border-b border-line bg-night py-20 sm:py-24" data-id="element-113" data-mp="1zjwhfw9i6m71">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-114" data-mp="2dahzxjv1ou4e">
        <div data-id="element-115" data-mp="28hyczwagwmmx">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-116" data-mp="28h6ot6j79r6o">
            Format
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-117" data-mp="2n9h00e1qvhfs">
            All the content is PDF. No video, no audio, no physical book.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60" data-id="element-118" data-mp="2s6qw2cjn2rcl">
            You get printable, ready-to-use documents your coaches can take
            straight to the pitch — no platform to log into, no course to sit
            through, and nothing to wait for in the post.
          </p>
          <ul className="mt-8 space-y-3" data-id="element-119" data-mp="2yzkqp0v9dgfb">
            {formatPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-120" data-mp="33ydtnzcx5p18">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-acid" aria-hidden="true" data-id="element-121" data-mp="33ynl7rdm4491" />
                <span className="text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-122" data-mp="3dop8wi21zknf">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <img src={images.sessionPlans} alt="Printed session plan templates with tactical diagrams beside a coach's clipboard" className="w-full border border-line object-cover" loading="lazy" data-id="element-123" data-mp="3molrq31rhpak" />
      </div>
    </section>;
}